export const ApiEndpoint = {
  PaddleOffering: 'paddle/offering',
  CustomerSubscriptions: '/paddle/customer/:customerId/subscriptions',
  MetaAds: 'meta-ads/events'
}
